import { parseCbsReportText } from "./parseCbsReportText";

// Keep the existing detailed CBS extraction for saved text, without another PDF download.
export const savedCbsData = (report) => {
  if (report?.status !== "completed") return null;
  let details = {};
  if (report.ocr_text) {
    try {
      details = Object.fromEntries(Object.entries(parseCbsReportText(report.ocr_text) || {}).filter(([, value]) =>
        value != null && !(typeof value === "number" && !Number.isFinite(value)) && value !== "NaN" && value !== "Infinity",
      ));
    } catch { /* The persisted structured fields remain available for unfamiliar layouts. */ }
  }
  return { ...details, ...(report.parsed_data || {}) };
};

export const creditReportMessage = (report, label) => {
  if (report?.status === "loading") return `Loading ${label} report analysis…`;
  if (["pending", "processing"].includes(report?.status)) return `${label} report is being processed. Results will appear automatically when ready.`;
  if (report?.status === "failed") return `${label} report could not be parsed. Please contact support to review the attachment.`;
  return null;
};

// Only replace the applicant's CBS. Corporate co-directors keep their own reports.
export const mergeLoanCbsData = (entries, report, name, userId) => {
  const existing = Array.isArray(entries) ? entries : [];
  if (!report || report.status === "legacy") return existing;
  const primary = {
    ...(existing[0] || {}),
    name: name || existing[0]?.name,
    user_id: userId || existing[0]?.user_id,
    cbs_data: savedCbsData(report),
  };
  return [primary, ...existing.slice(1)];
};
